import axiosClient from '@/core/axiosClient'
const resource = '/api/mobilization'

export default {
  async getMobilizationsForDay (date: Date) {
    try {
      const formattedDate = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
      const response = await axiosClient.get(`${resource}/mobilizationsForDay/?date=${formattedDate}`)
      return { state: 'success', data: response.data }
    } catch (error: any) {
      if (error.message === 'Network Error') {
        // Håndter offline-tilstand
        console.log('Offline-tilstand: Ingen netværksforbindelse')
        return { state: 'offline', data: null }
      } else {
        // Håndter andre fejl
        console.error('Fejl under anmodning:', error.message)
        return { state: 'error', data: null }
      }
    }
  },
  async getMobilizationsForMonth (year: number, month: number) {
    try {
      const response = await axiosClient.get(`${resource}/mobilizationsForMonth/?year=${year}&month=${month}`)
      return { state: 'success', data: response.data }
    } catch (error: any) {
      if (error.message === 'Network Error') {
        // Håndter offline-tilstand
        console.log('Offline-tilstand: Ingen netværksforbindelse')
        return { state: 'offline', data: null }
      } else {
        // Håndter andre fejl
        console.error('Fejl under anmodning:', error.message)
        return { state: 'error', data: null }
      }
    }
  }
}

function pad (num: number): string {
  return num < 10 ? '0' + num : num.toString()
}
